import styled from "styled-components"

export const ResumeSectionTitle = styled.h3`
  text-align: center;
  margin-top: 1rem;
  font-weight: 400;
  font-family: Pacifico;
  font-size: 1.5rem;
`